


































































import { Component, Vue, Watch } from "vue-property-decorator";
import * as types from "@/store/types";
import { UsersService } from "@/services/api/users.service";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import SingleImageUploaderComponent from "@/components/uploaders/SingleImageUploader.vue";
import { Getter } from "vuex-class";
import { UserDto } from "@/server/app.dtos";

@Component({
  components: {
    SingleImageUploader: SingleImageUploaderComponent
  }
})
export default class AccountProfilePage extends Vue {
  @Getter("profile") profile!: UserDto;
  @Watch("profile")
  onProfileChanged(): void {
    this.user.init(this.profile);
  }
  user: UserDto = new UserDto();
  usersService: UsersService = new UsersService();
  isLoading: boolean = false;
  isValid: boolean = false;
  editor: string = "";

  created() {
    this.user.init(this.profile);
  }

  onSelectPhoto(photo: string): void {
    if (photo) {
      this.user.photo = photo;
    }
  }

  onSaveProfile(): void {
    if (this.isLoading) return;
    if (!this.isValid) {
      NotificationServiceBus.showErrorMessage(
        "Atenção",
        "Insira todos os dados obrigatórios"
      );
      return;
    }
    this.isLoading = true;
    this.usersService
      .SaveProfile(this.user as UserDto)
      .then(() => {
        this.$store.dispatch(types.PROFILE_UPDATE, this.user);
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Os seus dados foram guardados com sucesso"
        );
      })
      .catch((error: any) => {
        NotificationServiceBus.showError(error);
      })
      .finally(() => (this.isLoading = false));
  }
}
